/* eslint-disable camelcase */

import { notifyError } from "common/utils/app-monitoring/notify";

export const NETWORK_ERROR_PATTERNS = [
  /network\s*error/i, // "Network Error", "NetworkError", "network connection"
  /timeout/i, // All timeout variations
  /ERR_NETWORK/i, // Axios error code
  /ERR_CANCELED/i, // Axios cancel code
  /net::ERR_/i, // All Chrome net errors
  /ECONNRESET/i,
  /ECONNABORTED/i,
  /ECONNREFUSED/i,
  /ETIMEDOUT/i,
  /ENOTFOUND/i,
  /request\s*aborted/i,
  /AbortError/i,
  /Failed to fetch/i, // Chrome/Edge fetch
  /Load failed/i, // Safari fetch
  /canceled/i, // Axios cancellation
  /offline/i, // Offline-related messages
  /internet connection/i, // Safari "Internet connection appears to be offline"
  /status code 499/i, // CloudFront client closed request
  /status code 504/i // Gateway timeout — infrastructure, not frontend bug
];

const isNetworkError = value => {
  if (!value || typeof value !== "string") return false;
  return NETWORK_ERROR_PATTERNS.some(pattern => pattern.test(value));
};

/**
 * Logs an upload artwork error to app monitoring.
 *
 * @param {object} payload - The payload containing error information.
 * @param {string} payload.error_message - The error message.
 * @param {string} payload.error - The error description.
 * @param {string} payload.handledError - The error is handled by backend validation.
 * @param {string} payload.uploadError - The error description for the upload.
 */
// eslint-disable-next-line import/prefer-default-export
export const logUploadError = payload => {
  const { error_message, error, handledError, uploadError, errorResponse } = payload;

  // Known errors that are not worth reporting
  // i.e. "Network Error" is not code related, but a network issue
  const knownErrors = ["Something went wrong while processing your artwork", "Network Error"];

  const isTimeoutError = errorResponse?.error_type === "timeout_error";

  if (
    knownErrors.includes(error) ||
    uploadError === "Processing error" ||
    handledError ||
    isTimeoutError ||
    isNetworkError(error) ||
    isNetworkError(error_message)
  )
    return;

  notifyError("Upload artwork error", {
    params: {
      error_message,
      error,
      uploadError,
      errorResponse
    }
  });
};
/* eslint-enable camelcase */
